export default function ReferralOutlineIcon({ width = 13, height = 13, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 12.8499 12.85'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M3.22493 3.62474C4.10859 3.62474 4.82494 2.90845 4.82494 2.02487C4.82494 1.14129 4.10859 0.425 3.22493 0.425C2.34127 0.425 1.62492 1.14129 1.62492 2.02487C1.62492 2.90845 2.34127 3.62474 3.22493 3.62474Z'
        stroke='currentColor'
        strokeWidth='0.85'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.02504 7.22541C6.02504 6.48286 5.73005 5.77076 5.20493 5.24567C4.67982 4.72061 3.96763 4.42564 3.22502 4.42564C2.4824 4.42564 1.77021 4.72061 1.24511 5.24567C0.719999 5.77076 0.425 6.48286 0.425 7.22541V8.42532H1.62714L2.02714 12.425H4.42716L4.82716 8.42532H6.02717L6.02504 7.22541Z'
        stroke='currentColor'
        strokeWidth='0.85'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.0249 6.02453C10.6615 6.02453 11.2719 6.27737 11.722 6.72741C12.1721 7.17746 12.4249 7.78786 12.4249 8.42434C12.4249 9.44879 10.9913 11.3985 10.3401 12.2315C10.3027 12.2794 10.2549 12.3181 10.2003 12.3447C10.1457 12.3714 10.0857 12.3852 10.0249 12.3852C9.96418 12.3852 9.90418 12.3714 9.84957 12.3447C9.79496 12.3181 9.74712 12.2794 9.70973 12.2315C9.05853 11.399 7.62492 9.44933 7.62492 8.42487C7.62486 8.1097 7.68689 7.79757 7.80748 7.50634C7.92801 7.21511 8.10481 6.95049 8.32769 6.72762C8.55052 6.50471 8.81516 6.32787 9.10637 6.20724C9.39757 6.08661 9.70973 6.02453 10.0249 6.02453Z'
        stroke='currentColor'
        strokeWidth='0.85'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.42709 0.425H8.42711C8.85143 0.425 9.25842 0.593557 9.55847 0.893591C9.85853 1.19363 10.0271 1.60056 10.0271 2.02487V4.42468'
        stroke='currentColor'
        strokeWidth='0.85'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.42501 2.82469L10.025 4.42457L11.625 2.82469'
        stroke='currentColor'
        strokeWidth='0.85'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
